export function contactsSearch() {
  $(document).on("click", ".contact-detail .btn-close", function (ev) {
    const parentCollapseId = $(this).parents(".collapse").first().attr("id");
    const $collapseBtn = $(`[data-target="#${parentCollapseId}"]`);
    $collapseBtn.click();
  });
}
